// extracted by mini-css-extract-plugin
module.exports =  {"switch":"switch--wxPqQ","right":"right--E5txR","btn":"btn--xOI3o"};